export const SUBSCRIPTION_SECTIONS = {
  PLANO: 'plano',
  FATURA: 'fatura',
  CREDITOS: 'creditos',
};

export const SUBSCRIPTION_PATH_BY_SECTION = {
  [SUBSCRIPTION_SECTIONS.PLANO]: '/subscription',
  [SUBSCRIPTION_SECTIONS.FATURA]: '/subscription/fatura',
  [SUBSCRIPTION_SECTIONS.CREDITOS]: '/subscription/creditos',
};

export const resolveSubscriptionSection = (pathname) => {
  if (pathname.startsWith('/subscription/plans/details')) return null;
  if (
    pathname.startsWith('/subscription/creditos') ||
    pathname.startsWith('/subscription/ai-credits')
  ) {
    return SUBSCRIPTION_SECTIONS.CREDITOS;
  }
  if (pathname.startsWith('/subscription/fatura') || pathname.startsWith('/subscription/invoice')) {
    return SUBSCRIPTION_SECTIONS.FATURA;
  }
  if (
    pathname === '/subscription' ||
    pathname.startsWith('/subscription/plano') ||
    pathname.startsWith('/subscription/plans')
  ) {
    return SUBSCRIPTION_SECTIONS.PLANO;
  }
  return null;
};

export const isSubscriptionAreaPath = (pathname) =>
  pathname === '/subscription' || pathname.startsWith('/subscription/');

/** URL canônica do hub (ou null se a rota não for do hub, ex.: detalhes do plano). */
export const getCanonicalSubscriptionPath = (pathname) => {
  if (pathname.startsWith('/subscription/plans/details')) return null;

  const section = resolveSubscriptionSection(pathname);
  if (section) {
    return SUBSCRIPTION_PATH_BY_SECTION[section];
  }

  if (isSubscriptionAreaPath(pathname)) {
    return SUBSCRIPTION_PATH_BY_SECTION[SUBSCRIPTION_SECTIONS.PLANO];
  }

  return null;
};
